<template>
  <Dialog :hide-close-button="true" v-bind="$attrs">
    <template #header-title
      >Você recebe o salário em alguma dessas instituições?</template
    >
    <template #content>
      Você tem chances de conseguir a oferta, mas é necessário receber o salário
      em alguma das seguintes instituições:

      <ul>
        <li>001 - Banco do Brasil</li>
        <li>033 - Banco Santander</li>
        <li>104 - Caixa Econômica Federal</li>
        <li>237- Banco Bradesco</li>
        <li>341 - Itaú Unibanco</li>
      </ul>
    </template>
    <template #footer>
      <Button :busy="busy" @click="handleInteraction(true)">
        Sim, eu recebo
      </Button>
      <Button :busy="busy" type="outlined" @click="handleInteraction(false)">
        Não, não recebo
      </Button>
    </template>
  </Dialog>
</template>
<script>
import Button from '@/aasgard/components/buttons/Button.vue'
import Dialog from '@/aasgard/components/modals/Dialog.vue'
export default {
  name: 'JBCredPreSelectOfferModal',
  components: {
    Button,
    Dialog,
  },
  props: {
    busy: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'submit'],
  methods: {
    handleInteraction(hasAccount) {
      if (hasAccount) {
        this.$emit('submit')
      } else {
        this.$emit('close')
      }
    },
  },
}
</script>
<style lang="scss"></style>
